import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { Input } from "reactstrap";
import { useMediaQuery } from "react-responsive";
import moment from "moment";
import { toast } from "react-toastify";

const PickDateRange = (props) => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);

  const todayStart = moment().startOf("day").toDate();
  const todayEnd = moment().endOf("day").toDate();
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 940px)",
  });
  const isSmallScreen = useMediaQuery({ query: "(max-width: 390px)" });

  const defaultDateState = [
    {
      startDate: todayStart,
      endDate: todayEnd,
      key: "selection",
    },
  ];

  const [dateState, setDateState] = useState(() => {
    return props.datestate?.length > 0 ? props.datestate : defaultDateState;
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  const handleDateChange = (item) => {
    const startDate = moment(item.selection.startDate).startOf("day").toDate();
    const endDate = moment(item.selection.endDate).endOf("day").toDate();

    const diffInDays = moment(endDate).diff(moment(startDate), "days");
    if (diffInDays > 60) {
      toast.error("Date range cannot exceed 60 days.");
      return;
    }

    const updatedDateState = [{ ...item.selection, startDate, endDate }];
    setDateState(updatedDateState);
    if (props.setDateState) {
      props.setDateState(updatedDateState);
    }
  };

  const dateRangeString = `${moment(dateState[0].startDate).format(
    "DD MMM YYYY"
  )} - ${moment(dateState[0].endDate).format("DD MMM YYYY")}`;

  return (
    <div ref={ref}>
      <Input
        value={dateRangeString}
        className="pointer bg-white"
        onClick={() => setIsOpen(!isOpen)}
        readOnly
        disabled={props.disabled}
      />

      {isOpen && !props.disabled && (
        <>
          {isDesktopOrLaptop ? (
            <DateRangePicker
              onChange={handleDateChange}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={2}
              ranges={dateState}
              direction="horizontal"
              preventSnapRefocus={true}
              calendarFocus="backwards"
              className="dateRangerSet"
              maxDate={
                !props.disablePast
                  ? moment().endOf("month").toDate()
                  : undefined
              }
              minDate={
                props.disablePast ? moment().startOf("day").toDate() : undefined
              }
            />
          ) : (
            <DateRangePicker
              onChange={handleDateChange}
              showSelectionPreview={true}
              moveRangeOnFirstSelection={false}
              months={1}
              ranges={dateState}
              direction="horizontal"
              preventSnapRefocus={true}
              calendarFocus="backwards"
              className="dateRangerSet"
              maxDate={moment().endOf("month").toDate()}
              staticRanges={[]}
            />
          )}
        </>
      )}
      {!isDesktopOrLaptop && (
        <style>{`.rdrDefinedRangesWrapper {display: none !important;}`}</style>
      )}
      {isSmallScreen && (
        <style>
          {`
          @media (max-width: 370px) {
            .rdrCalendarWrapper {
              max-width: 280px !important;
              font-size: 12px !important;
            }
            .rdrDateDisplayWrapper {
              flex-direction: column !important;
            }
            .rdrMonth {
              width: 100% !important;
            }
            .rdrDay {
              font-size: 10px !important;
              min-width: 30px !important;
              height: 30px !important;
            }
          }
        `}
        </style>
      )}
    </div>
  );
};

export default PickDateRange;
